export const TOGGY_BANNER_SESSION_KEY = 'toggy-moderate-banner-dismissed:strip'
/** Strip height in px. Only numeric source — CSS and the trial overlay read this. */
export const TOGGY_BANNER_HEIGHT_PX = 48
export const TOGGY_BANNER_HEIGHT = `${TOGGY_BANNER_HEIGHT_PX}px`
export const TOGGY_BANNER_HEIGHT_VAR = '--toggy-banner-height'
export const TOGGY_BANNER_HREF = 'https://toggy.ai'

export const isToggyBannerDismissed = (): boolean => {
  try {
    return sessionStorage.getItem(TOGGY_BANNER_SESSION_KEY) === '1'
  } catch {
    return false
  }
}

export const dismissToggyBanner = (): void => {
  try {
    sessionStorage.setItem(TOGGY_BANNER_SESSION_KEY, '1')
  } catch {
    // Private mode / storage disabled — fail silently.
  }
}

export const toggyBannerHeightRootCss = (): string =>
  `:root { ${TOGGY_BANNER_HEIGHT_VAR}: ${TOGGY_BANNER_HEIGHT}; }`
